import { render, staticRenderFns } from "./QuestionStatus.vue?vue&type=template&id=2d064bc8&scoped=true"
import script from "./QuestionStatus.vue?vue&type=script&lang=js"
export * from "./QuestionStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d064bc8",
  null
  
)

export default component.exports